import axios from "axios";

var counter = 0;
const win: any = window;
var apigeeReGenerateTokenUrl: any = win["regenerate_url"];
var serverURL: any = win["base_portal_url"];
var errorPage: any = win["errorPageURL"];
let clientToken = window.location.href.includes("localhost") ? import.meta.env.VITE_APP_BMT : win["clientToken"];
const apigeeBMXAPIKey = window.location.href.includes("localhost") ? import.meta.env.VITE_APP_CMK : win['apigee_bm_x_api_key']
const apiBaseURL = window.location.href.includes("localhost") ? "https://apisit.mobily.com.sa" : win["apigee_bm_base_url"];

const apigeeConfig = {
    api: {
        baseURL: apiBaseURL,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "x-api-key": apigeeBMXAPIKey,
            "X-Source-Channel": "Portals",
            "X-Transaction-Id": String(new Date().getTime())
        },
    },
}

export const apigeeSimpleApi = axios.create();
export const apigeeApi = axios.create({ ...apigeeConfig.api });

apigeeApi.defaults.validateStatus = function () {
    return true;
};

apigeeApi.interceptors.request.use(
    async (conf: any) => {
        conf.headers.Authorization = `Bearer ${clientToken}`;
        return conf;
    },
    (err) => {
        console.log("error in getting ", err);
    }
);

apigeeApi.interceptors.response.use(
    async (response) => {
        if (
            (response.data.code && response.data.code === "APIGEE-001") ||
            (response.data.code && response.data.code === "APIGEE-002")
        ) {
            counter++;
            clientToken = await reGenerateToken();
            const { config: oldRequest } = response;
            if (counter < 2) return apigeeApi.request({ ...oldRequest });
        }

        return response;
    },
    async (error) => {
        if (!!errorPage) {
            document.location.href = errorPage;
        }
        return error;
    }
);

function reGenerateToken() {
    console.log("apigeeReGenerateTokenUrl :: Enter");
    console.log("apigeeReGenerateTokenUrl => " + serverURL + "" + apigeeReGenerateTokenUrl);

    return new Promise((resolve, reject) => {
        fetch(serverURL + "" + apigeeReGenerateTokenUrl, {
            method: "GET",
            headers: {
                "Content-type": "text/html; charset=UTF-8",
            },
        })
            .then((res) => res.text())
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

// get method

const getOrderByExternalId = (orderId: string, xCoId: string) => {
    const url = `${apiBaseURL}/OrderGenerator/fetchByOrderId/${orderId}`;
    return apigeeApi.get(url, {
        headers: {
            "X-Correlation-Id": xCoId
        }
    });
};

const codProductOrderDetails = (orderId: string, xCoId: string) => {
    const data = {
        "orderId": orderId
    }
    return apigeeApi.post(`${apiBaseURL}/OrderGenerator/retryProductOrder`, data, {
        headers: {
            "X-Correlation-Id": xCoId
        }
    });
}

export { getOrderByExternalId, codProductOrderDetails };